import * as React from 'react';

export default () => {
  return <div className="loader" />
};